import React ,{useEffect} from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import feather from 'feather-icons';



const Faq = () => {

    useEffect(() => {
            feather.replace();
        }, []); 
     
    return (

        <>
        <Header/>
            <main class="main">
               <div className="breadcrumb-wrap" id="breadcrumb-margin">
                    <div className="banner" style={{minHeight:'10px'}}>
                        {/* <img class="img-fluidbg-top" src="assets/images/inner-page/banner-p-2.html" alt="banner" /> */}
                        <div class="container-lg">
                            <div class="breadcrumb-box">
                                <div class="heading-box">
                                    <h1>User Dashboard</h1>
                                </div>
                                <ol class="breadcrumb">
                                    <li><a href="/">Home</a></li>

                                    <li>
                                        <a href="javascript:void(0)"><i data-feather="chevron-right"></i></a>
                                    </li>

                                    <li class="current"><a href="/accounts">User Dashboard</a></li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </div>

                <section class="user-dashboard">
                    <div class="container-lg">
                        <div class="row g-3 g-xl-4 tab-wrap">
                            <div class="col-lg-4 col-xl-3 ">
                                <button class="setting-menu btn-solid btn-sm d-lg-none">Setting Menu <i class="arrow"></i></button>
                                <div class="side-bar">
                                    <span id="closeSidebar" class="back-side d-lg-none"> <i data-feather="x"></i></span>


                                    <ul class="nav nav-tabs nav-tabs2" id="myTab" role="tablist">
                                        <li class="nav-item" role="presentation">
                                            <button class="nav-link" id="orders-tab" data-bs-toggle="tab" data-bs-target="#orders" type="button" role="tab" aria-controls="orders" aria-selected="false">
                                                payment
                                                <span><i data-feather="chevron-right"></i></span>
                                            </button>
                                        </li>
                                        <li class="nav-item" role="presentation">
                                            <button class="nav-link" id="payment-tab" data-bs-toggle="tab" data-bs-target="#payment" type="button" role="tab" aria-controls="orders" aria-selected="false">
                                                payment
                                                <span><i data-feather="chevron-right"></i></span>
                                            </button>
                                        </li>
                                        <li class="nav-item" role="presentation">
                                            <button class="nav-link" id="wishlist-tab" data-bs-toggle="tab" data-bs-target="#wishlist" type="button" role="tab" aria-controls="orders" aria-selected="false">
                                                returns
                                                <span><i data-feather="chevron-right"></i></span>
                                            </button>

                                        </li>
                                        <li class="nav-item" role="presentation">
                                            <button class="nav-link" id="savedAddress-tab" data-bs-toggle="tab" data-bs-target="#savedAddress" type="button" role="tab" aria-controls="savedAddress" aria-selected="false">
                                                Dispatch & Delivery
                                                <span><i data-feather="chevron-right"></i></span>
                                            </button>
                                        </li>

                                        <li class="nav-item" role="presentation">
                                            <button class="nav-link" id="profile-tab" data-bs-toggle="tab" data-bs-target="#profile" type="button" role="tab" aria-controls="profile" aria-selected="false">
                                                Customization
                                                <span><i data-feather="chevron-right"></i></span>
                                            </button>
                                        </li>

                                    </ul>
                                </div>
                            </div>

                            <div class="col-lg-8 col-xl-9">
                                <div class="right-content tab-content" id="myTabContent">
                                    <div class="tab-pane show active" id="dashboard" role="tabpanel" aria-labelledby="dashboard-tab">
                                        <div class="dashboard-tab">
                                            <div class="title-box3">
                                                <h3>Welcome, you can clarify yours quries here...</h3>

                                            </div>


                                        </div>
                                    </div>


                                    <div class="tab-pane" id="orders" role="tabpanel" aria-labelledby="orders-tab">
                                        <div class="cart-wrap order-content">
                                            <div class="title-box3">
                                                <h3>FAQ</h3>
                                                <p>Orders</p>
                                            </div>

                                            <div class="order-wraper">
                                                <div class="payment-section">
                                                    <div class="row g-3 g-xl-4">
                                                        <div class='col-md-12'>

                                                            <details>
                                                                <summary class='toggler_1'>
                                                                    <div class='offer-box'>
                                                                        <h4 style={{color:'#911077'}}>Is there an assisted checkout available to place an order?</h4>
                                                                    </div>
                                                                </summary>
                                                                <div class='tog_content'>
                                                                    <p class="mt-2" style={{fontSize:'20px'}}>Yes, we have a customer support team to assist you in placing an order. You can directly make a call or Whatsapp to our customer service team at 99622 15000 or e-mail us at support@welbeing.in.
                                                                    </p>
                                                                </div>
                                                            </details>
                                                        </div>


                                                        <div class='col-md-12'>

                                                            <details>
                                                                <summary class='toggler_1'>
                                                                    <div class='offer-box'>
                                                                        <h2 style={{color:'#911077'}}><strong>How do I know if my order has been confirmed?
                                                                        </strong></h2>
                                                                    </div>
                                                                </summary>
                                                                <div class='tog_content'>
                                                                    <p class="mt-2"style={{fontSize:'20px'}}>Once you place the order, your order will be confirmed (after making payment) and a confirmation message will be sent through email.
                                                                    </p>
                                                                </div>
                                                            </details>
                                                        </div>

                                                        <div class='col-md-12'>

                                                            <details>
                                                                <summary class='toggler_1'>
                                                                    <div class='offer-box'>
                                                                        <h2 style={{color:'#911077'}}><strong>What is the accepted timeline for order cancellation?
                                                                        </strong></h2>
                                                                    </div>
                                                                </summary>
                                                                <div class='tog_content'>
                                                                    <p class="mt-2"style={{fontSize:'20px'}}>Orders placed can be cancelled for valid and appropriate reasons only. After approval of cancellation by our team, orders can be cancelled within 24hours from the time of order placed.
                                                                    </p>
                                                                </div>
                                                            </details>
                                                        </div>


                                                        <div class='col-md-12'>

                                                            <details>
                                                                <summary class='toggler_1'>
                                                                    <div class='offer-box'>
                                                                        <h2 style={{color:'#911077'}}><strong>Can I change the products/shipping address after payment has been made?
                                                                        </strong></h2>
                                                                    </div>
                                                                </summary>
                                                                <div class='tog_content'>
                                                                    <p class="mt-2"style={{fontSize:'20px'}}>Yes, you can change your order contents and shipping address within 24hours of placing the order only.
                                                                    </p>
                                                                </div>
                                                            </details>
                                                        </div>


                                                        <div class='col-md-12'>

                                                            <details>
                                                                <summary class='toggler_1'>
                                                                    <div class='offer-box'>
                                                                        <h2 style={{color:'#911077'}}><strong>How can I check my order status?

                                                                        </strong></h2>
                                                                    </div>
                                                                </summary>
                                                                <div class='tog_content'>
                                                                    <p class="mt-2"style={{fontSize:'20px'}}>Once the order has been shipped, you will receive the order tracking details through email and you can check the status of your order.
                                                                    </p>
                                                                </div>
                                                            </details>
                                                        </div>






                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>



                                    <div class="tab-pane" id="payment" role="tabpanel" aria-labelledby="payment-tab">
                                        <div class="cart-wrap order-content">
                                            <div class="title-box3">
                                                <h3>FAQ</h3>
                                                <p>Orders</p>
                                            </div>

                                            <div class="order-wraper">
                                                <div class="payment-section">
                                                    <div class="row g-3 g-xl-4">
                                                        <div class='col-md-12'>

                                                            <details>
                                                                <summary class='toggler_1'>
                                                                    <div class='offer-box'>
                                                                        <h2 style={{color:'#911077'}}><strong>Is there an assisted checkout available to place an order?
                                                                        </strong></h2>
                                                                    </div>
                                                                </summary>
                                                                <div class='tog_content'>
                                                                    <p class="mt-2"style={{fontSize:'20px'}}>Yes, we have a customer support team to assist you in placing an order. You can directly make a call or Whatsapp to our customer service team at 99622 15000 or e-mail us at support@welbeing.in.
                                                                    </p>
                                                                </div>
                                                            </details>
                                                        </div>


                                                        <div class='col-md-12'>

                                                            <details>
                                                                <summary class='toggler_1'>
                                                                    <div class='offer-box'>
                                                                        <h2 style={{color:'#911077'}}><strong>How do I know if my order has been confirmed?
                                                                        </strong></h2>
                                                                    </div>
                                                                </summary>
                                                                <div class='tog_content'>
                                                                    <p class="mt-2"style={{fontSize:'20px'}}>Once you place the order, your order will be confirmed (after making payment) and a confirmation message will be sent through email.
                                                                    </p>
                                                                </div>
                                                            </details>
                                                        </div>

                                                        <div class='col-md-12'>

                                                            <details>
                                                                <summary class='toggler_1'>
                                                                    <div class='offer-box'>
                                                                        <h2 style={{color:'#911077'}}><strong>What is the accepted timeline for order cancellation?
                                                                        </strong></h2>
                                                                    </div>
                                                                </summary>
                                                                <div class='tog_content'>
                                                                    <p class="mt-2"style={{fontSize:'20px'}}>Orders placed can be cancelled for valid and appropriate reasons only. After approval of cancellation by our team, orders can be cancelled within 24hours from the time of order placed.
                                                                    </p>
                                                                </div>
                                                            </details>
                                                        </div>


                                                        <div class='col-md-12'>

                                                            <details>
                                                                <summary class='toggler_1'>
                                                                    <div class='offer-box'>
                                                                        <h2 style={{color:'#911077'}}><strong>Can I change the products/shipping address after payment has been made?
                                                                        </strong></h2>
                                                                    </div>
                                                                </summary>
                                                                <div class='tog_content'>
                                                                    <p class="mt-2"style={{fontSize:'20px'}}>Yes, you can change your order contents and shipping address within 24hours of placing the order only.
                                                                    </p>
                                                                </div>
                                                            </details>
                                                        </div>


                                                        <div class='col-md-12'>

                                                            <details>
                                                                <summary class='toggler_1'>
                                                                    <div class='offer-box'>
                                                                        <h2 style={{color:'#911077'}}><strong>How can I check my order status?

                                                                        </strong></h2>
                                                                    </div>
                                                                </summary>
                                                                <div class='tog_content'>
                                                                    <p class="mt-2"style={{fontSize:'20px'}}>Once the order has been shipped, you will receive the order tracking details through email and you can check the status of your order.
                                                                    </p>
                                                                </div>
                                                            </details>
                                                        </div>






                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>



                                    <div class="tab-pane" id="savedAddress" role="tabpanel" aria-labelledby="savedAddress-tab">
                                        <div class="cart-wrap order-content">
                                            <div class="title-box3">
                                                <h3>FAQ</h3>
                                                <p>Orders</p>
                                            </div>

                                            <div class="order-wraper">
                                                <div class="payment-section">
                                                    <div class="row g-3 g-xl-4">
                                                        <div class='col-md-12'>

                                                            <details>
                                                                <summary class='toggler_1'>
                                                                    <div class='offer-box'>
                                                                        <h2 style={{color:'#911077'}}><strong>Is there an assisted checkout available to place an order?
                                                                        </strong></h2>
                                                                    </div>
                                                                </summary>
                                                                <div class='tog_content'>
                                                                    <p class="mt-2"style={{fontSize:'20px'}}>Yes, we have a customer support team to assist you in placing an order. You can directly make a call or Whatsapp to our customer service team at 99622 15000 or e-mail us at support@welbeing.in.
                                                                    </p>
                                                                </div>
                                                            </details>
                                                        </div>


                                                        <div class='col-md-12'>

                                                            <details>
                                                                <summary class='toggler_1'>
                                                                    <div class='offer-box'>
                                                                        <h2 style={{color:'#911077'}}><strong>How do I know if my order has been confirmed?
                                                                        </strong></h2>
                                                                    </div>
                                                                </summary>
                                                                <div class='tog_content'>
                                                                    <p class="mt-2"style={{fontSize:'20px'}}>Once you place the order, your order will be confirmed (after making payment) and a confirmation message will be sent through email.
                                                                    </p>
                                                                </div>
                                                            </details>
                                                        </div>

                                                        <div class='col-md-12'>

                                                            <details>
                                                                <summary class='toggler_1'>
                                                                    <div class='offer-box'>
                                                                        <h2 style={{color:'#911077'}}><strong>What is the accepted timeline for order cancellation?
                                                                        </strong></h2>
                                                                    </div>
                                                                </summary>
                                                                <div class='tog_content'>
                                                                    <p class="mt-2"style={{fontSize:'20px'}}>Orders placed can be cancelled for valid and appropriate reasons only. After approval of cancellation by our team, orders can be cancelled within 24hours from the time of order placed.
                                                                    </p>
                                                                </div>
                                                            </details>
                                                        </div>


                                                        <div class='col-md-12'>

                                                            <details>
                                                                <summary class='toggler_1'>
                                                                    <div class='offer-box'>
                                                                        <h2 style={{color:'#911077'}}><strong>Can I change the products/shipping address after payment has been made?
                                                                        </strong></h2>
                                                                    </div>
                                                                </summary>
                                                                <div class='tog_content'>
                                                                    <p class="mt-2"style={{fontSize:'20px'}}>Yes, you can change your order contents and shipping address within 24hours of placing the order only.
                                                                    </p>
                                                                </div>
                                                            </details>
                                                        </div>


                                                        <div class='col-md-12'>

                                                            <details>
                                                                <summary class='toggler_1'>
                                                                    <div class='offer-box'>
                                                                        <h2 style={{color:'#911077'}}><strong>How can I check my order status?

                                                                        </strong></h2>
                                                                    </div>
                                                                </summary>
                                                                <div class='tog_content'>
                                                                    <p class="mt-2"style={{fontSize:'20px'}}>Once the order has been shipped, you will receive the order tracking details through email and you can check the status of your order.
                                                                    </p>
                                                                </div>
                                                            </details>
                                                        </div>






                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>


                                    <div class="tab-pane" id="wishlist" role="tabpanel" aria-labelledby="wishlist-tab">
                                        <div class="cart-wrap order-content">
                                            <div class="title-box3">
                                                <h3>FAQ</h3>
                                                <p>Orders</p>
                                            </div>

                                            <div class="order-wraper">
                                                <div class="payment-section">
                                                    <div class="row g-3 g-xl-4">
                                                        <div class='col-md-12'>

                                                            <details>
                                                                <summary class='toggler_1'>
                                                                    <div class='offer-box'>
                                                                        <h2 style={{color:'#911077'}}><strong>Is there an assisted checkout available to place an order?
                                                                        </strong></h2>
                                                                    </div>
                                                                </summary>
                                                                <div class='tog_content'>
                                                                    <p class="mt-2"style={{fontSize:'20px'}}>Yes, we have a customer support team to assist you in placing an order. You can directly make a call or Whatsapp to our customer service team at 99622 15000 or e-mail us at support@welbeing.in.
                                                                    </p>
                                                                </div>
                                                            </details>
                                                        </div>


                                                        <div class='col-md-12'>

                                                            <details>
                                                                <summary class='toggler_1'>
                                                                    <div class='offer-box'>
                                                                        <h2 style={{color:'#911077'}}><strong>How do I know if my order has been confirmed?
                                                                        </strong></h2>
                                                                    </div>
                                                                </summary>
                                                                <div class='tog_content'>
                                                                    <p class="mt-2"style={{fontSize:'20px'}}>Once you place the order, your order will be confirmed (after making payment) and a confirmation message will be sent through email.
                                                                    </p>
                                                                </div>
                                                            </details>
                                                        </div>

                                                        <div class='col-md-12'>

                                                            <details>
                                                                <summary class='toggler_1'>
                                                                    <div class='offer-box'>
                                                                        <h2 style={{color:'#911077'}}><strong>What is the accepted timeline for order cancellation?
                                                                        </strong></h2>
                                                                    </div>
                                                                </summary>
                                                                <div class='tog_content'>
                                                                    <p class="mt-2"style={{fontSize:'20px'}}>Orders placed can be cancelled for valid and appropriate reasons only. After approval of cancellation by our team, orders can be cancelled within 24hours from the time of order placed.
                                                                    </p>
                                                                </div>
                                                            </details>
                                                        </div>


                                                        <div class='col-md-12'>

                                                            <details>
                                                                <summary class='toggler_1'>
                                                                    <div class='offer-box'>
                                                                        <h2 style={{color:'#911077'}}><strong>Can I change the products/shipping address after payment has been made?
                                                                        </strong></h2>
                                                                    </div>
                                                                </summary>
                                                                <div class='tog_content'>
                                                                    <p class="mt-2"style={{fontSize:'20px'}}>Yes, you can change your order contents and shipping address within 24hours of placing the order only.
                                                                    </p>
                                                                </div>
                                                            </details>
                                                        </div>


                                                        <div class='col-md-12'>

                                                            <details>
                                                                <summary class='toggler_1'>
                                                                    <div class='offer-box'>
                                                                        <h2 style={{color:'#911077'}}><strong>How can I check my order status?

                                                                        </strong></h2>
                                                                    </div>
                                                                </summary>
                                                                <div class='tog_content'>
                                                                    <p class="mt-2"style={{fontSize:'20px'}}>Once the order has been shipped, you will receive the order tracking details through email and you can check the status of your order.
                                                                    </p>
                                                                </div>
                                                            </details>
                                                        </div>






                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="tab-pane" id="profile" role="tabpanel" aria-labelledby="profile-tab">
                                        <div class="cart-wrap order-content">
                                            <div class="title-box3">
                                                <h3>FAQ</h3>
                                                <p>Orders</p>
                                            </div>

                                            <div class="order-wraper">
                                                <div class="payment-section">
                                                    <div class="row g-3 g-xl-4">
                                                        <div class='col-md-12'>

                                                            <details>
                                                                <summary class='toggler_1'>
                                                                    <div class='offer-box'>
                                                                        <h2 style={{color:'#911077'}}><strong>Is there an assisted checkout available to place an order?
                                                                        </strong></h2>
                                                                    </div>
                                                                </summary>
                                                                <div class='tog_content'>
                                                                    <p class="mt-2"style={{fontSize:'20px'}}>Yes, we have a customer support team to assist you in placing an order. You can directly make a call or Whatsapp to our customer service team at 99622 15000 or e-mail us at support@welbeing.in.
                                                                    </p>
                                                                </div>
                                                            </details>
                                                        </div>


                                                        <div class='col-md-12'>

                                                            <details>
                                                                <summary class='toggler_1'>
                                                                    <div class='offer-box'>
                                                                        <h2 style={{color:'#911077'}}><strong>How do I know if my order has been confirmed?
                                                                        </strong></h2>
                                                                    </div>
                                                                </summary>
                                                                <div class='tog_content'>
                                                                    <p class="mt-2"style={{fontSize:'20px'}}>Once you place the order, your order will be confirmed (after making payment) and a confirmation message will be sent through email.
                                                                    </p>
                                                                </div>
                                                            </details>
                                                        </div>

                                                        <div class='col-md-12'>

                                                            <details>
                                                                <summary class='toggler_1'>
                                                                    <div class='offer-box'>
                                                                        <h2 style={{color:'#911077'}}><strong>What is the accepted timeline for order cancellation?
                                                                        </strong></h2>
                                                                    </div>
                                                                </summary>
                                                                <div class='tog_content'>
                                                                    <p class="mt-2"style={{fontSize:'20px'}}>Orders placed can be cancelled for valid and appropriate reasons only. After approval of cancellation by our team, orders can be cancelled within 24hours from the time of order placed.
                                                                    </p>
                                                                </div>
                                                            </details>
                                                        </div>


                                                        <div class='col-md-12'>

                                                            <details>
                                                                <summary class='toggler_1'>
                                                                    <div class='offer-box'>
                                                                        <h2 style={{color:'#911077'}}><strong>Can I change the products/shipping address after payment has been made?
                                                                        </strong></h2>
                                                                    </div>
                                                                </summary>
                                                                <div class='tog_content'>
                                                                    <p class="mt-2"style={{fontSize:'20px'}}>Yes, you can change your order contents and shipping address within 24hours of placing the order only.
                                                                    </p>
                                                                </div>
                                                            </details>
                                                        </div>


                                                        <div class='col-md-12'>

                                                            <details>
                                                                <summary class='toggler_1'>
                                                                    <div class='offer-box'>
                                                                        <h2 style={{color:'#911077'}}><strong>How can I check my order status?

                                                                        </strong></h2>
                                                                    </div>
                                                                </summary>
                                                                <div class='tog_content'>
                                                                    <p class="mt-2"style={{fontSize:'20px'}}>Once the order has been shipped, you will receive the order tracking details through email and you can check the status of your order.
                                                                    </p>
                                                                </div>
                                                            </details>
                                                        </div>



                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

            </main>

        <Footer/>


        </>
    )
}
export default Faq;